/**
 * @prettier
 */
export const FacturamaPaymentMethods = {
    ONE_EXHIBITION: 'PUE',
    BY_PARTS: 'PPD',
} as const;

export type FacturamaPaymentMethod = typeof FacturamaPaymentMethods[keyof typeof FacturamaPaymentMethods];
